import Vue from 'vue';
import corelogicApiServices from './corelogicapi';
import googleApiServices from './googleapi';
import oaApiServices from './oaapi';
import prospectorProApiServices from './prospectorproapi';

Vue.mixin({
  beforeCreate() {
    const options = this.$options;
    if (options.apiServices) {
      this.$apiServices = options.apiServices;
    } else if (options.parent && options.parent.$apiServices) {
      this.$apiServices = options.parent.$apiServices;
    }
  },
});

const apiServices = {
  cl: corelogicApiServices,
  google: googleApiServices,
  oa: oaApiServices,
  pp: prospectorProApiServices,
};

export default apiServices;
